
import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';

interface NavItemButtonContentProps { 
  title: string; 
  Icon: React.ElementType; 
  expanded: boolean; 
  isMobile: boolean; 
  badgeCount: number | null; 
  isExpanded: boolean;
}

const NavItemButtonContent: React.FC<NavItemButtonContentProps> = ({
  title,
  Icon,
  expanded,
  isMobile,
  badgeCount,
  isExpanded
}) => {
  return (
    <>
      <Icon size={20} className={cn("flex-shrink-0", expanded || isMobile ? "mr-3" : "")} />
      {(expanded || isMobile) && (
        <>
          <span className="flex-1 text-left">{title}</span>
          {badgeCount !== null && (
            <Badge variant="default" className="ml-auto h-5 min-w-5 rounded-full flex items-center justify-center">{badgeCount}</Badge>
          )}
          {isExpanded ? <ChevronUp size={16} className="ml-2" /> : <ChevronDown size={16} className="ml-2" />}
        </>
      )}
      {!expanded && !isMobile && badgeCount !== null && (
        <Badge variant="default" className="absolute -top-1 -right-1 h-5 w-5 rounded-full flex items-center justify-center p-0 text-xs">{badgeCount}</Badge>
      )}
    </>
  );
};

export default NavItemButtonContent;
